(ns dre.widgets.related-concepts.views
  (:require
   [dre.components.icon :refer [fa-icon]]
   [dre.components.pill :as pill]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils.bem :as bem-utils]
   [dre.pages.search.events :as search-events]
   [dre.widgets.related-concepts.events :as-alias events]
   [re-frame.core :as rf]))

(def component-name :related-concepts)

(defn- action-buttons
  [parent pill children]
  [:div
   {:class (bem-utils/be component-name :list-item-actions)}
   [tooltip-wrapper "Remove this concept from search" [:div
                                                       {:class [(bem-utils/be component-name :list-item-action)
                                                                (bem-utils/bem component-name :list-item-action :remove)]
                                                        :on-click #(rf/dispatch [::search-events/remove-from-query
                                                                                 parent pill children])}
                                                       [fa-icon :x-mark]]]
   [tooltip-wrapper "Use this concept in place of parent" [:div
                                                           {:class [(bem-utils/be component-name :list-item-action)
                                                                    (bem-utils/bem component-name :list-item-action :open)]
                                                            :on-click #(rf/dispatch [::search-events/replace-in-query
                                                                                     parent pill])}
                                                           [fa-icon :level-up]]]])

(defn- list-item
  [parent->children row]
  (let [type (get-in row [:pill :pill/type])
        {:keys [parent pill]} row
        children (get parent->children (:pill/query parent))]
    [:div
     {:class (bem-utils/be component-name :list-item)}
     [pill/pills
      (:query/pills (:term row))
      {:indent (= :senses (:subtype row))
       :excluded (:excluded row)}]
     (when-not (or (#{:senses :text} type)
                   (not parent))
       [action-buttons parent pill children])]))

(defn widget-content
  [data]
  [:div
   {:class component-name}
   (if (not (seq data))
     [no-result true]
     [:div
      {:class (bem-utils/be component-name :list)}
      (let [rf (fn [acc {:keys [parent pill]}]
                 (if parent
                   (update acc (:pill/query parent) conj pill)
                   acc))
            parent->children (reduce rf {} data)]
        (map-indexed (fn [idx row]
                       ^{:key idx} [list-item parent->children row])
                     data))])])

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        data @(rf/subscribe [::events/data])
        loading? (= :loading (:state state))]
    [widget-base/view id [title-with-filter title id] [widget-content data]
     {:csv-event [::events/export]
      :export-image? false}
     {:loading? loading?}]))
